import { z } from 'zod';

import { CompanyId, PoolId } from '../BrandedIds';
import { zodBrandedString, zodBrandedUuid } from '../utils/Zod';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const UpsertPoolSideEffectContext = BaseLoanIdSideEffect.extend({
  poolId: zodBrandedString<PoolId>(),
  companyId: zodBrandedUuid<CompanyId>(),
});
export const UpsertPoolSideEffect = UpsertPoolSideEffectContext.extend({
  type: z.literal('upsertPool'),
});
export type UpsertPoolSideEffect = z.infer<typeof UpsertPoolSideEffect>;
